export enum EnumTpCondicaoApuracao {
    ValorFixo,
    Percentual
};